export enum CRMUserStatusEnum {
  Undefined,
  Available,
  Unavailable,
}
